var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9767 21.0911C17.2563 21.3706 17.6354 21.5276 18.0307 21.5276C18.426 21.5276 18.8051 21.3706 19.0847 21.0911L25.7933 14.3825C26.0728 14.1029 26.2298 13.7238 26.2298 13.3285C26.2298 12.9332 26.0728 12.5541 25.7933 12.2745L19.0847 5.56589C18.8035 5.29433 18.427 5.14406 18.0361 5.14746C17.6452 5.15086 17.2713 5.30764 16.9949 5.58405C16.7185 5.86045 16.5617 6.23437 16.5583 6.62525C16.5549 7.01613 16.7051 7.39271 16.9767 7.67388L21.0123 11.8377H6.84969C6.4543 11.8377 6.07511 11.9948 5.79553 12.2743C5.51595 12.5539 5.35889 12.9331 5.35889 13.3285C5.35889 13.7239 5.51595 14.1031 5.79553 14.3827C6.07511 14.6622 6.4543 14.8193 6.84969 14.8193H21.0123L16.9767 18.9831C16.6972 19.2627 16.5402 19.6418 16.5402 20.0371C16.5402 20.4324 16.6972 20.8115 16.9767 21.0911Z",
    fill: "#2A6ED4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowright);
export default __webpack_public_path__ + "static/media/arrowright.e43688ccacd29b890ae5ad7f7f6037f6.svg";
export { ForwardRef as ReactComponent };